module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ded-t"
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within these pages you will find six wool appliqué designs to create. I embellished each project with embroidery (which I see as drawing with needle and thread), adding interest to the design.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I have always favored the form and function aspect of art, each project contains directions to create a useful item that showcases your work. At the back of the book, you’ll find a chapter on all the embroidery stitches you will need for the projects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you are new to wool appliqué, this book will teach you how to begin. If you are experienced at the craft, I hope you find these projects enjoyable to create.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1012437c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/0004_chapter-title-1.vue
// module id = 66
// module chunks = 0